<template>
	<app-content class="h-panel">
		
		<router-view/>
	</app-content>
</template>

<script>
	export default {
		name: "salarymanage",
		data() {
			return {
				
				selected: 'Salarymanage'
			}
		},
		methods: {
			change(data) {
				this.$router.push({name: data.key})
			}
		}
	}
</script>